export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const EMAIL = "email";
export const KEYROCK_TOKEN = "keyrockToken";
export const PUBLICIP = "publicIP";
export const color1 = 'rgb(0,104,178)';
export const color2 = 'rgb(35,148,212)';
export const color3 = 'rgb(122,207,242)';
export const color4 = 'rgb(203,234,247)';

